<template>
  <footer class="henan">
    <div class="content">
      <div class="link flex">
        <span class="name">友情链接：</span>
        <ul class="links flex">
          <li><a href="https://www.cdpee.org.cn/">中国残联就业创业</a></li>
          <li><a href="https://www.ncss.cn/">新职业网</a></li>
          <li><a href="http://www.newjobs.com.cn/">中国国家人才网</a></li>
          <li><a href="http://www.chinaemployment.gov.cn/">中国就业网</a></li>
          <li><a href="http://www.cjob.gov.cn/">中国公共招聘网</a></li>
          <li><a href="https://www.chsi.com.cn/">学信网</a></li>
          <li><a href="https://www.zhaopin.com/">智联招聘</a></li>
          <li><a href="http://china.findlaw.cn/ask/">找法网</a></li>
          <li><a href="https://www.lagou.com/">拉勾网</a></li>
          <li><a href="http://www.hzyhzp.com/">余杭招聘网</a></li>
          <li><a href="http://www.18jobs.com/">远创人才网</a></li>
        </ul>
      </div>
      <ul class="list">
        <li class="li">
          <h3>常见问题</h3>
          <ul>
            <li class="trans">
              <a href="">如何使用视频招聘</a>
            </li>
            <!-- <li>
              <a href="">关于我们</a>
            </li>
            <li>
              <a href="">招聘指南</a>
            </li> -->
          </ul>
        </li>
        <li class="li">
          <h3>服务指南</h3>
          <ul>
            <li class="trans">
              <a href="">如何使用视频招聘</a>
            </li>
            <!-- <li>
              <a href="">隐私声明</a>
            </li>
            <li>
              <a href="">求职指南</a>
            </li> -->
          </ul>
        </li>
        <li class="li li_c">
          <h3>联系我们</h3>
          <ul>
            <li class="trans">
              <a href="javascript:void(0);">残疾人用户热线：010-68060691 </a>
            </li>
            <li class="trans">
              <a href="javascript:void(0);">企业、服务机构热线：010-68060651</a>
            </li>
            <li class="trans">
              <a href="javascript:void(0);">中心电话：0311-89255052/89255053</a>
            </li>
            <li class="trans">
              <a href="javascript:void(0);">地址：河北省石家庄市钟宏路2号</a>
            </li>

          </ul>
        </li>
        <li class="li text_c">
          <img src="@/static/gzh.jpg" alt="" />
          <h3>移动端官网</h3>
        </li>
        <li class="li text_c">
          <img src="@/static/public/hebeiPic.jpg" alt="" />
          <h3>微信公众号</h3>
        </li>
      </ul>
      <div class="server">
        <ul>
          <li class="trans">网站管理及技术支持：河北省残疾人就业服务中心</li>
          <li class="trans">网站运营单位：浙江浙大网新软件产业集团有限公司</li>
          <li class="trans">网站备案：<a href="https://beian.miit.gov.cn/#/Integrated/index" style="color: white" target="_blank">京ICP备12035391号-2</a></li>
          <li class="trans">版权所有：河北省残疾人就业服务中心</li>
          <li class="trans">Copyright © 2015-2019 WWW.CDPEE.ORG.CN all Rights Reserved.</li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped lang="less">
footer {
  padding-top: 28px;
  height: auto;
  background: #28a46d;
  .trans {
    color: rgba(255, 255, 255blue, 0.8) !important;
    a {
      color: rgba(255, 255, 255blue, 0.8) !important;
    }
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    .link {
      color: #ffffff;
      .name {
        width: 100px;
        font-size: 16px;
      }
      .links {
        width: 100%;
        justify-content: space-between;
        li {
          a {
            color: #ffffff;
            font-size: 14px;
          }

          a:hover {
            color: #ffffff;
          }
        }
      }
    }

    .list {
      margin-top: 32px;
      margin-bottom: 46px;
      display: flex;
      justify-content: space-between;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        bottom: -36px;
        width: 1200px;
        height: 1px;
        background: rgba(255, 255, 255blue, 0.3);
      }
      .li {
        flex: 1;
        h3 {
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 28px;
        }

        ul {
          margin-top: 24px;
          position: relative;
          li {
            margin-bottom: 15px;
            a {
              color: #ffffff;
              line-height: 20px;
            }
          }
        }

        img {
          width: 114px;
          border-radius: 8px;
          // margin-top: 24px;
        }
        &.li_c{
          flex: 3;
          ul{
            display: flex;
            flex-wrap: wrap;
            li{
              width: 50%;
            }
          }
        }
        &:last-child{
          margin-left: 24px;
        }
      }
      .text_c {
        flex: 0.5;
        h3{
          font-weight: 500;
          font-size: 16px;
        }
      }
    }

    .server {
      margin-top: 20px;
      padding-bottom: 24px;
      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
          padding-bottom: 10px;
          color: #ffffff;
          line-height: 20px;
        }
        li:last-child {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}
</style>
